import Vue from 'vue'

const toastr = {
  success: (closeOnSwipe = true, duration = 1e3 * 5) => {
    Vue.toasted.success('Data has been saved.', {icon: 'fa-check', closeOnSwipe, duration})
  },
  info: (text, closeOnSwipe = true, duration = 1e3 * 5) => {
    Vue.toasted.info(text, {icon: 'fa-info-circle', closeOnSwipe, duration})
  },
  error: (text, closeOnSwipe, duration = 1e3 * 5) => {
    Vue.toasted.error(text, {icon: 'fa-exclamation-circle', closeOnSwipe, duration})
  },
  serverError: () => {
    Vue.toasted.global.server_error()
  }
}

export default toastr
